import React, { useEffect } from 'react';
import { getTodayDate } from "../../util/Utils"

const To = ({ toDate, setToDate }) => {
  useEffect(() => {
    if (!toDate) {
      const formattedDate = getTodayDate(); // Format date as YYYY-MM-DD
      setToDate(formattedDate); // Set the To date
    }
  }, [toDate, setToDate]);

  const handleToDateChange = (e) => {
    setToDate(e.target.value);  
  };

  return (
    <>
      <input
        type="date"
        id="toDate"
        name="toDate"
        value={toDate}
        onChange={handleToDateChange}
        className="bg-light text-black rounded-input small-input"
      />
    </>
  );
};

export default To;
